module.exports = __webpack_public_path__ + "static/media/icon-twitter.35bb10fb.svg";